import Swiper from '@src/components/swiper';
import { screenResizerChecker } from '@src/utils/screen-resizer-checker';
import { ScreensInt } from '@tailwindConfig/screens.config';

export const swiperOfferCards = () => {
  let addedExtraSpacing = false;

  const bulletText = (index) => {
    const swiperWrapper = document.getElementsByClassName('swiper-offer-cards')[0];
    const offerPlansData = JSON.parse(swiperWrapper.getAttribute('data-offer-plans'));
    return `<span>${offerPlansData[index].title}</span>\
      <span class="bullet-offer-price"> ${offerPlansData[index].price}</span>`;
  };

  const addExtraSpacing = (swiperParent) => {
    swiperParent.style.marginBottom = '84px';
    addedExtraSpacing = true;
  };

  const removeExtraSpacing = (swiperParent) => {
    swiperParent.style.marginBottom = '52px';
    addedExtraSpacing = false;
  };

  // If the height of bullet texts is more than 40px, text is on two lines so we add extra spacing.
  const checkBulletTextHeight = () => {
    const bulletTexts = document.getElementsByClassName('bullet-text');
    if (bulletTexts.length === 0) { return; };
    const swiperParent = bulletTexts[0].closest('.swiper-pagination');
    if (bulletTexts[0].offsetHeight > 40) {
      if (!addedExtraSpacing) {
        addExtraSpacing(swiperParent);
      }
    } else {
      if (addedExtraSpacing) {
        removeExtraSpacing(swiperParent);
      }
    }
  };

  const generateSwiperOfferCards = () => {
    new Swiper('.swiper-offer-cards', {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 55,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletActiveClass: 'swiper-pagination-bullet-active',
        bulletClass: 'h2 swiper-pagination-bullet swiper-pagination-offer-cards',
        renderBullet: (index, className) => {
          return `<div class="${className}">\
                    <div class="bullet-text">${bulletText(index)}</div>\
                  </div>`;
        }
      }
    });

    // Add extra spacing when the text of the bullets is on two lines (small windows on mobile).
    checkBulletTextHeight();
  };

  const removeSwiperOfferCards = () => {
    document.querySelectorAll('.swiper-offer-cards').forEach(element => {
      if (element.swiper) {
        element.swiper.destroy();
      }
    });
  };

  screenResizerChecker(() => generateSwiperOfferCards(), () => removeSwiperOfferCards(), ScreensInt.md);
};

document.addEventListener('DOMContentLoaded', function (_event) {
  swiperOfferCards();
});
